(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {
    var articleSingle = document.querySelector('.single-page'),
        articleAuthors;

    // author tabs
    if(articleSingle) {
        articleAuthors = articleSingle.querySelectorAll('.authors li');

        [].forEach.call( articleAuthors, function(author) {
            author.addEventListener('click', function(e) {
                e.stopPropagation();
                if (typeof(author) != 'undefined' && author != null) {
                    if (author.querySelector('.about') != null) {
                        [].forEach.call( articleAuthors, function(author) {
                            author.querySelector('.about').classList.remove('visible');
                        });

                        this.querySelector('.about').classList.add('visible');
                    }
                }
            });
            if (author.querySelector('.about') != null) {
                author.querySelector('.close').addEventListener('click', function(e) {
                    e.stopPropagation();
                    this.parentNode.classList.remove('visible');
                });
            }
        });
        document.body.addEventListener('click', function(e) {
            [].forEach.call( articleAuthors, function(author) {
                if (author.querySelector('.about') != null) {
                    author.querySelector('.about').classList.remove('visible');
                }
            });
        });
    }

    // disabled copy article
    document.addEventListener('copy', function (e){
        e.preventDefault();
        var domainName = document.URL;
        textToCopy = window.getSelection().toString();
        e.clipboardData.setData('text/plain', textToCopy);
    });
});